import React, { useEffect } from 'react';
import { X } from 'lucide-react';

// Website khulepachhi dekhine notice — photo + title clickable (link ma redirect)
function NoticeModal({ open, notice, onClose, onOpenLink }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    if (open) window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open || !notice) return null;

  const clickable = Boolean(notice.link);

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4" style={{ zIndex: 90 }} onClick={onClose}>
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden relative"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="बन्द गर्नुहोस्"
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-crimson transition-colors z-10"
        >
          <X size={18} />
        </button>

        <div
          className={`group ${clickable ? 'cursor-pointer' : ''}`}
          onClick={() => clickable && onOpenLink(notice.link)}
        >
          {notice.image ? (
            <img
              src={notice.image}
              alt={notice.title || 'Notice'}
              className="w-full max-h-[60vh] object-cover group-hover:scale-[1.02] transition-transform duration-300"
            />
          ) : (
            <div className="h-40 bg-gradient-to-br from-crimson to-crimson-dark" />
          )}
          {notice.title && (
            <div className={`px-5 py-4 ${clickable ? 'bg-paper-soft' : ''}`}>
              <h3 className={`font-display text-lg font-bold text-center leading-snug transition-colors ${clickable ? 'text-blue group-hover:text-crimson group-hover:underline' : 'text-ink'}`}>
                {notice.title}
                {clickable && <span className="block text-[11px] font-semibold text-muted mt-1">थिच्नुहोस् → पूरा हेर्नुहोस्</span>}
              </h3>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NoticeModal;